import { Directive, HostListener } from "@angular/core";
import { NgControl } from "@angular/forms";

@Directive({
  selector: "[app-no-lead-ws]",
})
export class NoLeadingTrailingWhiteSpaceDirective {
  constructor(private input: NgControl) { }

  @HostListener("keypress", ["$event"])
  onInputChange(event: KeyboardEvent) {
    if ((event.target as HTMLInputElement).selectionStart === 0 && event.key === " ") {
      event.preventDefault();
    }
  }

  @HostListener("blur", ["$event"])
  onBlur(event: Event) {
    this.input?.control?.setValue((event.target as HTMLInputElement).value.trimEnd());
  }
}
